var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-cascader", {
    attrs: {
      fieldNames: {
        label: "name",
        value: "code",
        children: "children"
      },
      options: _vm.areaData,
      placeholder: _vm.$t(_vm.placeholder),
      disabled: _vm.disabled,
      allowClear: false
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.selectedValues,
      callback: function ($$v) {
        _vm.selectedValues = $$v;
      },
      expression: "selectedValues"
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };